
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ParentApiService } from './parent-api-service';


@Injectable({ providedIn: 'root' })
export class TemplateApiService extends ParentApiService {

  constructor(private http: HttpClient) { super(); }

  public getPUImporterTemplate() {
    const url = `${environment.webApiAddress}/api/templates/PackagingUnitImporterTemplate`;
    return this.http.get(url, { responseType: 'blob' });
  }
  public getPUImporterTemplateWithData(ids: { id: number, version: number }[]) {
    const url = `${environment.webApiAddress}/api/templates/ExportPackagingUnitsInExcelTemplate`;
    return this.http.put(url,ids,{ responseType: 'blob' });
  }
  public checkPUsStructureForExcelTemplate(ids: { id: number, version: number }[]) {
    const url = `${environment.webApiAddress}/api/templates/CheckPUsStructureForExcelTemplate`;
    return this.http.put(url,ids);
  }
}
